<app-modal
  [title]="'External vouchers' | trans:'vouchers/external-vouchers-modal/header/title'"
  maxWidth="728px"
  width="100%"
>
  <ng-template>
    <div>
      <p class="t4 fw-medium text-uppercase">
        {{ 'Voucher types' | trans:'vouchers/external-vouchers-modal/voucher-types.Title' }}
      </p>

      <div class="m-t-8 d-flex gap-24 flex-wrap">
        @for (voucherType of vouchersStore.externalVoucherTypes(); track voucherType.voucherTypeId) {
          <app-chip
            [value]="voucherType.voucherTypeId"
            [selected]="voucherType.voucherTypeId === selectedVoucherType?.voucherTypeId"
            [label]="voucherType.name"
            [disabled]="voucherType.voucherTypeId !== selectedVoucherType?.voucherTypeId"
            (onClick)="selectVoucherType(voucherType)"
          />
        }
      </div>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Cancel'| trans:'vouchers/external-vouchers-modal/cancel.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<app-voucher-code-input-modal #voucherCodeInputModal />
<app-voucher-amount-picker-modal #voucherAmountPickerModal />
<app-external-voucher-ticket-picker-modal
  #distributorTicketPickerModal
  (ticketSelected)="onDistributorTicketSelected($event)"
/>
